import { Box, Typography, Divider, Switch } from "@mui/material";
import { colorTextPrimary, colorTextMuted, colorBorder, colorAccent } from "./tokens";

interface ServiceRowProps {
  label: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  divider?: boolean;
  disabled?: boolean;
}

export const ServiceRow = ({
  label,
  description,
  checked,
  onChange,
  divider = true,
  disabled = false,
}: ServiceRowProps) => (
  <>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        py: 1.5,
      }}
    >
      <Box>
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: colorTextPrimary, mb: description ? 0.25 : 0 }}
        >
          {label}
        </Typography>
        {description && (
          <Typography variant="caption" sx={{ color: colorTextMuted }}>
            {description}
          </Typography>
        )}
      </Box>
      <Switch
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        size="small"
        sx={{
          "& .MuiSwitch-switchBase.Mui-checked": { color: colorAccent },
          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: colorAccent,
          },
        }}
      />
    </Box>
    {divider && <Divider sx={{ borderColor: colorBorder }} />}
  </>
);
